import type { RootState } from 'common/types'

export const selectHomeFilters = (state: RootState) => state.filters.homeFilters
export const selectListingFilters = (state: RootState) => state.filters.listingFilters
export const selectNetworkFilters = (state: RootState) => state.filters.networkFilters
export const selectNetworkModalFilters = (state: RootState) => state.filters.networkModalFilters
